import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => `${(x.loc || []).slice(-1)[0] || ""} ${x.msg || ""}`.trim()).join(", ") || fallback;
  if (d && typeof d === "object" && d.message) return d.message;
  return typeof d === "string" ? d : fallback;
};

api.interceptors.response.use(r => r, (e) => {
  if (e?.response?.status === 403 && e.response.data?.detail === "demo_expired" && e.config?.url !== "/api/auth/me" && !/^\/demo-(expired|access|login)/.test(window.location.pathname)) window.location.assign("/demo-expired");
  return Promise.reject(e);
});

export const upload = async (url, fd) => {
  const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}${url}`, { method: "POST", body: fd, credentials: "include" });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) { const e = new Error("upload"); e.response = { status: r.status, data }; throw e; }
  return { data };
};

export default api;
